/**
 * Subdomain Helper Utility
 * Detects and extracts subdomain from the current URL
 */

/**
 * Get the subdomain from the current hostname
 * @returns {string|null} - The subdomain or null if on main domain
 */
export const getSubdomain = () => {
  const hostname = window.location.hostname;
  
  // Development/localhost check
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('localhost')) {
    return null;
  }
  
  // Split hostname into parts
  const parts = hostname.split('.');
  
  // If we have more than 2 parts (e.g., subdomain.mahstry.com)
  // and it's not 'www', then we have a subdomain
  if (parts.length >= 3) {
    const subdomain = parts[0];
    
    // Ignore 'www' as a subdomain
    if (subdomain === 'www') {
      return null;
    }
    
    return subdomain;
  }
  
  return null;
};

/**
 * Check if current URL is on a subdomain
 * @returns {boolean}
 */
export const isOnSubdomain = () => {
  return getSubdomain() !== null;
};

/**
 * Get the main domain URL
 * @returns {string}
 */
export const getMainDomain = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('localhost')) {
    return `${protocol}//${hostname}${window.location.port ? ':' + window.location.port : ''}`;
  }
  
  const parts = hostname.split('.');
  
  // Get last two parts (mahstry.com)
  if (parts.length >= 2) {
    const mainDomain = parts.slice(-2).join('.');
    return `${protocol}//${mainDomain}`;
  }
  
  return `${protocol}//${hostname}`;
};

/**
 * Build a subdomain URL
 * @param {string} subdomain - The subdomain to use
 * @param {string} path - Optional path (default: '/')
 * @returns {string}
 */
export const buildSubdomainUrl = (subdomain, path = '/') => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('localhost')) {
    // In development, use path-based routing
    return `${protocol}//${hostname}${window.location.port ? ':' + window.location.port : ''}/institute/${subdomain}${path}`;
  }
  
  const parts = hostname.split('.');
  const mainDomain = parts.slice(-2).join('.');
  
  return `${protocol}//${subdomain}.${mainDomain}${path}`;
};
